export default __webpack_public_path__ + "static/media/jana.918ef8bd.jpg";